var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "w-full col-span-full"
  }, [_c('info-bulle', {
    attrs: {
      "libelle": _vm.labelLibelle,
      "name": _vm.name,
      "is-libelle-input": true
    },
    scopedSlots: _vm._u([{
      key: "libelleBefore",
      fn: function () {
        return [_c('p', {
          staticClass: "text-sm text-gray-600 font-normal truncate mb-2",
          style: _vm.inherits != undefined && _vm.inherits != null && _vm.inherits ? 'color: inherit; font-size: inherit; font-weight: inherit;' : '',
          attrs: {
            "for": _vm.name
          },
          domProps: {
            "innerHTML": _vm._s(_vm.libelle)
          },
          on: {
            "mouseover": function ($event) {
              _vm.tooltipLibelle = true;
            },
            "mouseleave": function ($event) {
              _vm.tooltipLibelle = false;
            }
          }
        }), _vm._v(" "), _vm.required ? _c('span', {
          staticClass: "text-pink-600 ml-1"
        }, [_vm._v("*")]) : _vm._e()];
      },
      proxy: true
    }, {
      key: "tooltipLibelleBefore",
      fn: function () {
        return [_c('transition', {
          attrs: {
            "enter-active-class": "duration-300 delay-1000",
            "enter-class": "opacity-0",
            "enter-to-class": "opacity-100",
            "leave-active-class": "duration-300",
            "leave-class": "opacity-100",
            "leave-to-class": "opacity-0"
          }
        }, [_vm.tooltipLibelle && _vm.libelle != null && _vm.libelle != '' ? _c('div', {
          staticClass: "absolute rounded-lg shadow-lg bg-indigo-600 text-white bottom-8 z-30 p-3 text-sm w-max-content w-max max-w-128"
        }, [_vm._v("\n          " + _vm._s(_vm.libelle) + "\n        ")]) : _vm._e()])];
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('div', {
    staticClass: "relative"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.mutableValue,
      expression: "mutableValue"
    }],
    staticClass: "bg-white border rounded-md placeholder-gray-600 px-3 py-2 xxl:px-4 xxl:py-3 2xl:px-5 2xl:py-4 block w-full focus:outline-none focus:shadow-outline-indigo focus:border-indigo-300 border-opacity-50 appearance-none transition duration-150 ease-in-out text-sm sm:leading-5",
    class: {
      'bg-gray-200 cursor-not-allowed': _vm.disabled || _vm.disabled_pass,
      'border-red-500': _vm.error && _vm.errorMsg != '',
      'border-indigo-600': !(_vm.error && _vm.errorMsg != '')
    },
    attrs: {
      "name": _vm.name,
      "rows": _vm.size,
      "necessary": _vm.progressCount,
      "disabled": _vm.disabled || _vm.disabled_pass,
      "required": _vm.required,
      "maxlength": _vm.maxlength
    },
    domProps: {
      "value": _vm.mutableValue
    },
    on: {
      "mouseover": function ($event) {
        _vm.tooltipValue = true;
      },
      "mouseleave": function ($event) {
        _vm.tooltipValue = false;
      },
      "blur": function ($event) {
        return _vm.blur();
      },
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.mutableValue = $event.target.value;
      }
    }
  }), _vm._v(" "), !_vm.disabled ? _c('div', {
    staticClass: "absolute mb-4 right-0 inset-y-0 pt-1 pr-6 flex items-center cursor-pointer"
  }, [_c('SpeechToText', {
    on: {
      "result": function (result) {
        return _vm.updateMutable(result);
      },
      "startRecognition": _vm.startRecognition,
      "stopRecognition": _vm.stopRecognition
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "duration-300 delay-300",
      "enter-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-active-class": "duration-300",
      "leave-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }
  })], 1), _vm._v(" "), _vm.error ? _c('div', {
    staticClass: "text-red-500 text-sm"
  }, [_vm._v("\n    " + _vm._s(_vm.errorMsg) + "\n  ")]) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }